module.exports = __webpack_public_path__ + "351d42b8f886843a299dff897e64f0fe.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-fr.html
// module id = 944
// module chunks = 0